export default "__VITE_PUBLIC_ASSET__920e4748__"